// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"921":"6ba11803","3726":"5fda3b5d","6664":"2d00b7cd"}[chunkId] + ".css";
};